import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Container from '../components/base/Container';
import PageTitle from '../components/base/PageTitle';
import Table from '../components/common/Table';
import { getRank, RankUser } from '../lib/api/user';

const ScoreTable = styled(Table)`
  tbody td {
    &:nth-child(1) {
      width: 5%;
      text-align: center;
    }
    &:nth-child(3) {
      width: 20%;
    }
    &:nth-child(4) {
      width: 20%;
      white-space: nowrap;
    }
  }
`;

interface ScoreboardPageProps {}

const ScoreboardPage: React.FC<ScoreboardPageProps> = () => {
  const [rank, setRank] = useState<RankUser[]>([]);

  useEffect(() => {
    getRank().then(({ data }) => {
      setRank(data);
    });
  }, []);

  return (
    <Container>
      <PageTitle>점수판</PageTitle>
      <ScoreTable>
        <thead>
          <tr>
            <th>#</th>
            <th>학생</th>
            <th>점수</th>
            <th>마지막으로 푼 시간</th>
          </tr>
        </thead>
        <tbody>
          {rank.map((user, i) => (
            <tr key={user.studentNumber}>
              <td>{i + 1}</td>
              <td>{`${user.studentNumber} ${user.name}`}</td>
              <td>{`${user.points}점`}</td>
              <td>{user.lastSolve ? new Date(user.lastSolve).toLocaleString() : '-'}</td>
            </tr>
          ))}
        </tbody>
      </ScoreTable>
    </Container>
  );
};

export default ScoreboardPage;
